import {MineComponent} from './mine.component';

export const mineRoutes = [
    {
        path: 'mine',
        component: MineComponent
    }
];